export default {
    topics: [
        {
            title: ' ApplyExtractionDef ',
            href: 'sm-supplier-ApplyExtractionDef.html',
            attributes: { 'data-id': 'sm-supplier-ApplyExtractionDef' },
            menu: { hasChildren: false },
            tocID: 'sm-supplier-ApplyExtractionDef-d66e3944',
            topics: [],
        },
        {
            title: ' initCostCenterList ',
            href: 'sm-supplier-initCostCenterList.html',
            attributes: { 'data-id': 'sm-supplier-initCostCenterList' },
            menu: { hasChildren: false },
            tocID: 'sm-supplier-initCostCenterList-d66e3952',
            topics: [],
        },
    ],
};

